var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.loading
    ? _c("div", { attrs: { id: "fieldList" } }, [
        _c(
          "div",
          { attrs: { id: "tableContainer" } },
          [
            !_vm.loading
              ? _c(
                  "el-table",
                  {
                    staticStyle: { width: "100%" },
                    attrs: {
                      data: _vm.appFields,
                      stripe: "",
                      "highlight-current-row": "",
                    },
                    on: { "row-click": _vm.handleActiveField },
                  },
                  _vm._l(_vm.columns, function (column) {
                    return _c("el-table-column", {
                      key: column.prop,
                      attrs: {
                        prop: column.label,
                        label: column.prop,
                        width: column.width,
                      },
                    })
                  }),
                  1
                )
              : _vm._e(),
          ],
          1
        ),
        _vm.activeAppField
          ? _c(
              "div",
              { attrs: { id: "activeAppField" } },
              [
                _c("app-field", {
                  key: _vm.activeAppField.appFieldId,
                  attrs: { _appField: _vm.activeAppField },
                }),
              ],
              1
            )
          : _c("div", { attrs: { id: "activeAppField" } }, [
              _vm._v(" No app field selected "),
            ]),
      ])
    : _c("div", [_vm._v(" Loading... ")])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }